
export default {
    name: 'plaintes',
    components: {},
    props: ["plaintes", "hn", "protocole_id", "can_show_empty"],
    data() {
        return {
            is_loading: true,
            is_empty: false
        }
    },

    watch: {
        plaintes() {
            this.getPlaintePatient()
        }
    },

    computed: {
        
    },

    mounted() {
        this.getPlaintePatient()
    },

    methods: {
        
        getPlaintePatient() {
            this.is_loading = true
            if (this.plaintes.length > 0) {
                this.is_empty = false
            } else {
                this.is_empty = true
            }

            setTimeout(() => {
                this.is_loading = false
            }, 500);
        }
    }
}


